import { render, staticRenderFns } from "./materialcategory.vue?vue&type=template&id=808a2fe8&"
import script from "./materialcategory.vue?vue&type=script&lang=js&"
export * from "./materialcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports